<h2 mat-dialog-title>Предупреждение о завершении сессии</h2>
<mat-dialog-content>
    <p>Ваша сессия скоро завершится из-за бездействия.</p>
    <p>Вы автоматически выйдете из системы через <strong>{{ countdown }}</strong> секунд.</p>
    <p>Если вы хотите продолжить работу, нажмите <strong>"Остаться в системе"</strong></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancelLogout()">Остаться в системе</button>
    <button mat-raised-button class="primary-color" (click)="onLogout()">Выйти из системы</button>
</mat-dialog-actions>